/**
 * Shared next/image quality and `sizes` hints for consistent, right-sized requests.
 * Tune alongside layout max-width tokens (`--max-width-narrow`, `--max-width-event-detail`).
 */

/** Full-width cover / hero — prioritize fidelity over bytes */
export const IMAGE_QUALITY_HERO = 88

/** Event cards, dashboard rows, marketing card thumbs */
export const IMAGE_QUALITY_CARD_THUMB = 85

/**
 * Hosting `/events` list row thumbs only — max fidelity (Next `images.qualities` must allow it).
 * Oversized `sizes` below pairs with this so the optimizer does not under-serve HiDPI.
 */
export const IMAGE_QUALITY_HOSTING_EVENTS_LIST_THUMB = 95

/**
 * Compact prominent dashboard list row thumb (~88px mobile / ~104px desktop CSS width) — Hosting
 * `/events`, Attending, and Archive timeline rows that share
 * `list-row-card-thumb--density-prominent`.
 */
export const IMAGE_SIZES_HOSTING_EVENTS_LIST_THUMB =
  "(max-width: 640px) 88px, 104px" as const

/** Dense album / timeline photo grids */
export const IMAGE_QUALITY_GALLERY_GRID = 85

/** Cover picker strip, small chrome thumbs */
export const IMAGE_QUALITY_STRIP_THUMB = 72

/** Marketing grids / non-critical preview tiles */
export const IMAGE_QUALITY_MARKETING_GRID = 82

/** Small circular avatars (roster chips, host pill) */
export const IMAGE_QUALITY_AVATAR = 68

/**
 * Create flow + any UI using `layout-shell-narrow` (max 40rem) inside `.app-shell`.
 * Padding approximates `--spacing-page-x` (1rem mobile) / `--spacing-page-x-sm` (1.5rem sm+).
 */
export const EVENT_COVER_NARROW_SHELL_SIZES =
  "(max-width: 639px) calc(100vw - 2rem), min(40rem, calc(100vw - 3rem))" as const

/**
 * Edit form and surfaces inside `EventDetailShell` (`--max-width-event-detail` 47.5rem).
 */
export const EVENT_COVER_DETAIL_SHELL_SIZES =
  "(max-width: 48rem) 100vw, 47.5rem" as const
